import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import Box from "../../../components/Box";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useMask } from "@react-input/mask";
import { toast } from "react-hot-toast";
import { storeActivityIndicator } from "../../../redux/reducers/authSlice";
import PageHeader from "../../../components/PageHeader";
import { Helpers } from "../../../helpers/Helpers";
import { AddStorageRequest } from "../../../models/request/storage/AddStorageRequest";
import GeneralInformation from "./Components/GeneralInformation";
import ShelfInformation from "./Components/ShelfInformation";
import AreaInformation from "./Components/AreaInformation";
import { GetStorageByIdResponse, GetStorageByIdResponseStorageArea, GetStorageByIdResponseStorageShelf } from "../../../models/response/storage/GetStorageByIdResponse";
import { StorageService } from "../../../services/StorageService";
import { AddStorageResponse } from "../../../models/response/storage/AddStorageResponse";

const StorageAdd = () => {
    const navigate = useNavigate();
    const pageName = "Depo Modülü > Tanımlamalar > Depo Tanımlama"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();

    const generalInformationRef: any = useRef();
    const areaRef: any = useRef();
    const shelfRef: any = useRef();

    const [storageId, setStorageId] = useState<string | undefined>(undefined);
    const [code, setCode] = useState<string | undefined>(undefined);
    const [phone1, setPhone1] = useState<string | undefined>(undefined);
    const phone1Ref = useMask({ mask: '(___) ___-__-__', replacement: { _: /\d/ } });
    const [palletCapacity, setPalletCapacity] = useState<string | undefined>(undefined);
    const [volumeCapacity, setVolumeCapacity] = useState<string | undefined>(undefined);
    const [isCustomActive, setIsCustomActive] = useState<boolean | undefined>(true);
    const [name, setName] = useState<string | undefined>(undefined);

    const [storageAreas, setStorageAreas] = useState<GetStorageByIdResponseStorageArea[]>([]);
    const [storageShelfs, setStorageShelfs] = useState<GetStorageByIdResponseStorageShelf[]>([]);

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, [])

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            if (id) {
                var response: GetStorageByIdResponse = await StorageService.getStorageById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setStorageId(response.data.storageId);
                setCode(response.data.code);
                setPhone1(response.data.phone1);
                setPalletCapacity(response.data.palletCapacity?.toFixed(2));
                setVolumeCapacity(response.data.volumeCapacity?.toFixed(2));
                setName(response.data.name);
                setIsCustomActive(response.data.isCustomActive);
                setStorageAreas(response.data.storageAreas);
                setStorageShelfs(response.data.storageShelfs);
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }
    const saveStorage = async () => {
        try {
            dispatch(storeActivityIndicator(true));

            var obj: AddStorageRequest = {
                storageId: storageId,
                code: code,
                name: name,
                isCustomActive: isCustomActive ? 1 : 0,
                palletCapacity: palletCapacity,
                phone1: phone1,
                volumeCapacity: volumeCapacity,
                storageAreas: storageAreas.map(function (x) {
                    return {
                        storageAreaTypeId: x.storageAreaTypeId,
                        isCustomActive: x.isCustomActive ? 1 : 0,
                        name: x.name
                    }
                }),
                storageShelfs: storageShelfs.map(function (x) {
                    return {
                        address: x.address,
                        storageShelfTypeId: x.storageShelfTypeId,
                        column: x.column,
                        corridor: x.corridor,
                        floor: x.floor,
                        isCustomActive: x.isCustomActive ? 1 : 0,
                        level: x.level
                    }
                })
            }

            var response: AddStorageResponse = await StorageService.addStorage(obj);

            if (!response.isSuccess) {
                toast.error(response.message);
                dispatch(storeActivityIndicator(false));
                return;
            }

            toast.success(response.message)

            dispatch(storeActivityIndicator(false));
            navigate(Helpers.getGoBackUrl())
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <PageHeader
                        items={[
                            { text: 'Genel Bilgiler', ref: generalInformationRef },
                            { text: 'Depo Alan Bilgileri', ref: areaRef },
                            { text: 'Depo Raf Bilgileri', ref: shelfRef },
                        ]}
                    />

                    <GeneralInformation
                        code={code}
                        generalInformationRef={generalInformationRef}
                        isCustomActive={isCustomActive}
                        palletCapacity={palletCapacity}
                        phone1={phone1}
                        phone1Ref={phone1Ref}
                        setCode={setCode}
                        setIsCustomActive={setIsCustomActive}
                        setPalletCapacity={setPalletCapacity}
                        setPhone1={setPhone1}
                        setVolumeCapacity={setVolumeCapacity}
                        volumeCapacity={volumeCapacity}
                        name={name}
                        setName={setName}
                    />

                    <AreaInformation
                        storageAreas={storageAreas}
                        areaRef={areaRef}
                        setStorageAreas={setStorageAreas}
                    />

                    <ShelfInformation
                        storageShelfs={storageShelfs}
                        setStorageShelfs={setStorageShelfs}
                        shelfRef={shelfRef}
                    />

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">

                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={saveStorage}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment>
    )
}

export default StorageAdd;